var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );
dependencies["contentful/ugc-pdp-carousel-item.j2"] = require( "contentful/ugc-pdp-carousel-item.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-pdp-carousel.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/contentful/ugc-pdp-carousel.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
env.getTemplate("macros/slider-macros.j2", false, "core/templates/contentful/ugc-pdp-carousel.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("create_slider_arrows")) {
var t_8 = t_5.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_8);
var t_9;
t_9 = (lineno = 3, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isFeatureEnabled"), "isFeatureEnabled", context, [runtime.contextOrFrameLookup(context, frame, "core"),"favorites"]));
frame.set("displayFavorites", t_9, true);
if(frame.topLevel) {
context.setVariable("displayFavorites", t_9);
}
if(frame.topLevel) {
context.addExport("displayFavorites", t_9);
}
output += "\n\n<div class=\"s-ugc s-ugc-pdp dom-ugc-tray-carousel\" data-qa-ugc-carousel>\n\n    <div class=\"c-ugc-pdp__carousel\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-slider__wrapper u-no-gutters\">\n\n                <div class=\"o-slider o-slider--ugc-product-image js-slider--product-image u-centered-content\">\n\n                    <div class=\"o-slider__inner js-slider__inner\">";
frame = frame.push();
var t_12 = runtime.contextOrFrameLookup(context, frame, "ugcItems");
if(t_12) {var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
output += "\n\n                            ";
var t_14;
t_14 = true;
frame.set("lazy", t_14, true);
if(frame.topLevel) {
context.setVariable("lazy", t_14);
}
if(frame.topLevel) {
context.addExport("lazy", t_14);
}
output += "\n                            ";
env.getTemplate("contentful/ugc-pdp-carousel-item.j2", false, "core/templates/contentful/ugc-pdp-carousel.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
})});
}
}
frame = frame.pop();
output += "</div>\n\n                </div>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugcItems")),"length") > 1) {
var t_19;
t_19 = (lineno = 30, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc arrow click","forward"]));
frame.set("nextAnalytics", t_19, true);
if(frame.topLevel) {
context.setVariable("nextAnalytics", t_19);
}
if(frame.topLevel) {
context.addExport("nextAnalytics", t_19);
}
output += "\n                    ";
var t_20;
t_20 = (lineno = 31, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc arrow click","back"]));
frame.set("prevAnalytics", t_20, true);
if(frame.topLevel) {
context.setVariable("prevAnalytics", t_20);
}
if(frame.topLevel) {
context.addExport("prevAnalytics", t_20);
}
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 33, colno = 41, runtime.callWrap(t_8, "create_slider_arrows", context, [runtime.makeKeywordArgs({"disablePrev": runtime.contextOrFrameLookup(context, frame, "True"),"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True"),"nextAnalytics": runtime.contextOrFrameLookup(context, frame, "nextAnalytics"),"prevAnalytics": runtime.contextOrFrameLookup(context, frame, "prevAnalytics")})])), env.opts.autoescape);
;
}
output += "</div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-pdp-carousel.j2"] , dependencies)